import 'whatwg-fetch';


const UTIL = {
  makeid: function (){
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for( var i=0; i < 10; i++ ){
        text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return text
  },
  objToArr: function(obj) {
    return Object.keys(obj).map(function(k) { return obj[k] });
  },
  firstIndexInObj: function(obj) {
    for (let a in obj) return a;
  },
  getParameterByName: function(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[[]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  shuffle(a) {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
  },
  getDate: function() {
    var d = new Date()
    var Month = d.getMonth()
    Month = Month + 1
    if (Month < 10) {Month = "0" + Month}
    var Date_tmp = d.getDate()
    if (Date_tmp < 10) {Date_tmp = "0" + Date_tmp;}
    var Hours = d.getHours()
    if (Hours < 10) {Hours = "0" + Hours;}
    var Minutes = d.getMinutes()
    if (Minutes < 10) {Minutes = "0" + Minutes}
    var Seconds = d.getSeconds()
    if (Seconds < 10) {Seconds = "0" + Seconds}
    var tmp_date = d.getFullYear() + "-" +  Month + "-" + Date_tmp + " " + Hours + ":" + Minutes + ":" + Seconds
    return tmp_date
  },
  throttle(delay, fn) {
    let lastCall = 0;
    return function (...args) {
      const now = (new Date).getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      return fn(...args);
    }
  }
};

export default UTIL;


// WEBPACK FOOTER //
// ./src/lib/util.js